const LLM_URL = process.env.REACT_APP_LLM_URL || 'http://localhost:5001';

async function authHeaders() {
  try {
    const { getToken } = await import('../firebase.js');
    const token = await getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

export async function batchUploadCDDI({ images, numBatches, testName, integrationId, workgroup, maxConcurrent, trainingProcessImprovement, guidanceMap }) {
  const fd = new FormData();
  fd.append('num_batches', String(numBatches));
  fd.append('test_name', String(testName || ''));
  if (integrationId) fd.append('integration_id', integrationId);
  if (workgroup) fd.append('workgroup', workgroup);
  if (maxConcurrent != null && maxConcurrent !== '' && Number(maxConcurrent) > 0) {
    fd.append('max_concurrent', String(maxConcurrent));
  }
  if (typeof trainingProcessImprovement === 'boolean') {
    fd.append('training_process_improvement', trainingProcessImprovement ? 'true' : 'false');
  }
  if (guidanceMap && typeof guidanceMap === 'object') {
    try {
      fd.append('guidance_map', JSON.stringify(guidanceMap));
    } catch {}
  }

  const isImage = (name) => /\.(png|jpe?g|gif|bmp|webp)$/i.test(name || '');
  (images || []).forEach((file) => {
    if (file && isImage(file.name)) {
      fd.append('images', file, file.name);
      // Align image_paths with images to enable guidance lookup server-side
      const rel = file.webkitRelativePath || file.relativePath || file.path || file.name;
      if (rel) fd.append('image_paths', rel);
    }
  });

  const headers = await authHeaders();
  const res = await fetch(`${LLM_URL}/v1/cddi/batch_upload`, {
    method: 'POST',
    headers,
    body: fd,
  });
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || `HTTP ${res.status}`);
  }
  return res.json();
}

// No JSON-mode transport here; JSON-mode in UI still uploads files via FormData

export async function analyseTestQuestionDifference({ target, comparisons = [] } = {}) {
  const normalizedTarget = target && typeof target === 'object' ? target : {};
  const normalizedComparisons = Array.isArray(comparisons)
    ? comparisons.filter((item) => item && typeof item === 'object')
    : [];

  const payload = {
    target: normalizedTarget,
    comparisons: normalizedComparisons,
  };

  if (normalizedTarget.qa_id && !payload.qa_id) {
    payload.qa_id = normalizedTarget.qa_id;
  }

  const integrationId = normalizedTarget.integration_id || normalizedTarget.integration;
  if (integrationId && !payload.integration_id) {
    payload.integration_id = integrationId;
  }
  if (integrationId && !payload.integration) {
    payload.integration = integrationId;
  }

  const res = await fetch(`${LLM_URL}/v1/analyseTestQuestionDifference`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(await authHeaders()),
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || `HTTP ${res.status}`);
  }

  return res.json();
}


